import React from "react";
import {
  useThemeStore,
  ThemePreference,
} from "components/main/stores/themeStore";
import { Radio } from "components/common/Radio";
import { SettingsRow } from "./SettingsRow";

const themeOptions: {
  value: ThemePreference;
  label: string;
  description: string;
}[] = [
  { value: "light", label: "Light", description: "Always use light theme" },
  { value: "dark", label: "Dark", description: "Always use dark theme" },
  {
    value: "system",
    label: "System",
    description: "Follow your system setting",
  },
];

export const AppearanceTab: React.FC = () => {
  const { preference, setPreference } = useThemeStore();

  return (
    <div className="flex flex-col gap-4">
      {themeOptions.map((option) => (
        <SettingsRow
          key={option.value}
          label={option.label}
          description={option.description}
          control={<Radio selected={preference === option.value} />}
          onClick={() => setPreference(option.value)}
        />
      ))}
    </div>
  );
};
